import { render, staticRenderFns } from "./SpellStats.vue?vue&type=template&id=6119e81a&scoped=true&"
import script from "./SpellStats.vue?vue&type=script&lang=js&"
export * from "./SpellStats.vue?vue&type=script&lang=js&"
import style0 from "./SpellStats.vue?vue&type=style&index=0&id=6119e81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6119e81a",
  null
  
)

export default component.exports